import { render } from "./App.vue?vue&type=template&id=876af91e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=876af91e&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876af91e"]])

export default __exports__